import { Navigate, useParams } from 'react-router-dom';
import { useGetDigitalTwinQuery } from '../../generated/graphql';
import { HelivanLoading } from '../HelivanLoading';
import { DigitalTwinView } from './DigitalTwinView';

export const DigitalTwinViewRoute = () => {
  const { digitalTwinId } = useParams();
  const { data, loading, error } = useGetDigitalTwinQuery({
    variables: { id: digitalTwinId || '' },
  });

  if (loading) {
    return <HelivanLoading />;
  }

  if (error || !data?.getDigitalTwinWithProjects) {
    return <Navigate to="/personas" replace />;
  }

  return <DigitalTwinView digitalTwin={data.getDigitalTwinWithProjects} />;
};
